import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/history-reconcile.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down-new.svg'


const _hoisted_1 = { class: "border rounded-lg shadow-sm bg-white" }
const _hoisted_2 = { class: "flex items-center space-x-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "riwayat",
  class: "w-4 h-4 mr-1"
}, null, -1)
const _hoisted_4 = { class: "font-semibold text-14px" }
const _hoisted_5 = {
  key: 0,
  class: "divide-y"
}
const _hoisted_6 = {
  class: "grid text-sm items-start gap-5",
  style: {"grid-template-columns":"70px 100px 140px 130px 330px"}
}
const _hoisted_7 = { class: "space-y-1" }
const _hoisted_8 = { class: "text-gray-lp-2700" }
const _hoisted_9 = { class: "font-semibold text-black" }
const _hoisted_10 = { class: "space-y-1" }
const _hoisted_11 = { class: "text-gray-lp-2700" }
const _hoisted_12 = { class: "font-semibold text-black" }
const _hoisted_13 = { class: "space-y-1" }
const _hoisted_14 = { class: "text-gray-lp-2700" }
const _hoisted_15 = { class: "font-semibold text-black" }
const _hoisted_16 = { class: "space-y-1" }
const _hoisted_17 = { class: "text-gray-lp-2700" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "space-y-1" }
const _hoisted_20 = { class: "text-gray-lp-2700" }
const _hoisted_21 = { class: "text-sm font-semibold text-black break-all" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "flex items-center justify-between px-4 py-3 border-b cursor-pointer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args)))
    }, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("codReconcile.detail.tabRiwayatSetorUang")), 1)
      ]),
      _createVNode("img", {
        src: _imports_1,
        alt: "chevron",
        class: ["w-4 h-4 inline-block transform transition-transform duration-300", { 'rotate-180': _ctx.expanded }]
      }, null, 2)
    ]),
    (_ctx.expanded)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.histories, (item, idx) => {
            return (_openBlock(), _createBlock("div", {
              key: idx,
              class: "px-4 py-3 flex flex-col space-y-1"
            }, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("codReconcile.detail.waktu")), 1),
                  _createVNode("p", _hoisted_9, _toDisplayString(_ctx.valueTime(item.updatedAt)) + " WIB ", 1)
                ]),
                _createVNode("div", _hoisted_10, [
                  _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.jumlahUangDisetor")), 1),
                  _createVNode("p", _hoisted_12, _toDisplayString(_ctx.formatDisplayAmount(item.amount)), 1)
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.totalStt")), 1),
                  _createVNode("p", _hoisted_15, [
                    _createTextVNode(_toDisplayString(item.stt.length) + " STT • ", 1),
                    _createVNode("a", {
                      href: "#",
                      class: "text-blue-600 hover:underline cursor-pointer",
                      onClick: () => _ctx.showModalStt(item.stt)
                    }, _toDisplayString(_ctx.$t("codReconcile.detail.lihatDetail")), 9, ["onClick"])
                  ])
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.foto")), 1),
                  (!item.photos.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_18, "-"))
                    : (_openBlock(), _createBlock("a", {
                        key: 1,
                        href: "#",
                        class: "text-blue-600 hover:underline font-semibold",
                        onClick: () => _ctx.showModalPreviewImage(item.photos)
                      }, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.lihatBukti")) + " (" + _toDisplayString(item.photos.length) + ") ", 9, ["onClick"]))
                ]),
                _createVNode("div", _hoisted_19, [
                  _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.catatan")), 1),
                  _createVNode("p", _hoisted_21, _toDisplayString(item.note), 1)
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}